import container from '@/container';
import {
    RelocationsType,
    RelocationsDirection,
    ConsumptionsType
} from '@/dto';
import { WindowsServiceContract, CONTRACTS } from '@/core/contracts';

import { StocksPageArgs } from './stocks/types';
import { ConsumptionsPageArgs } from './consumptions/types';
import { RelocationsPageArgs } from './relocations/types';
import { ResourcesUsagePageArgs } from './resourcesUsage';
import { ProductRelocationsPageArgs } from './productRelocations/types';

type IndicatorHandler = () => string;

function open(componentName: string, componentArgs?: any): IndicatorHandler {
    return () => container
        .get<WindowsServiceContract>(CONTRACTS.WindowsService)
        .open(componentName, componentArgs);
}

// tslint:disable: object-literal-key-quotes
export const indicatorsHandlers: { [key: string]: IndicatorHandler } = {
    'freeStockProposalsSm': open('stocks-page', {
        freeStockProposalsSm: true,
    } as StocksPageArgs),

    'freeStockProposalsSmValue': open('stocks-page', {
        freeStockProposalsSm: true,
    } as StocksPageArgs),

    'minUsageStock': open('stocks-page', {
        minUsage: true,
    } as StocksPageArgs),

    'incomingFixedRelocations': open('relocations-page', {
        type: RelocationsType.FIXED,
        direction: RelocationsDirection.INCOMING,
    } as RelocationsPageArgs),

    'productRelocations': open('product-relocations-page', {
        onlyAgreements: false
    } as ProductRelocationsPageArgs),

    'productRelocationAgreements': open('product-relocations-page', {
        onlyAgreements: true
    } as ProductRelocationsPageArgs),

    'changeDeliveryProposals': open('consumptions-page', {
        type: ConsumptionsType.DELIVERY_PROPOSALS,
    } as ConsumptionsPageArgs),

    'stock': open('stocks-page'),

    'freeStockCandidates': open('stocks-page', {
        freeStockCandidates: true,
    } as StocksPageArgs),

    'postponedConsumptions': open('consumptions-page', {
        type: ConsumptionsType.POSTPONED,
    } as ConsumptionsPageArgs),

    'unsatisfiedConsumptions': open('consumptions-page', {
        type: ConsumptionsType.UNSATISFIED,
    } as ConsumptionsPageArgs),

    'carUsage': open('resources-usage-page', {
        type: ['Relocation'],
    } as ResourcesUsagePageArgs),

    'warehouseEquipmentUtilisation': open('resources-usage-page', {
        type: [
            'Loading', 'Unloading',
        ]
    } as ResourcesUsagePageArgs),

    'consumptions': open('consumptions-page'),
    'preliminaryConsumptions': open('consumptions-page', {
        type: ConsumptionsType.PRELIMINARY,
        extdata: 'предварительные'
    } as ConsumptionsPageArgs),
    'activitySchedulesList': open('activity-schedules-list-page'),
    'dayInactivityIntervalsList': open('day-inactivity-intervals-list-page'),
    'cranesList': open('cranes-list-page'),
    'operationalPlanSummary': open('operational-plan-summary-page'),
    'plannedOperations': open('planned-operations-page'),
    'logisticWorkplace': open('logistic-workplace-page'),
    'productsList': open('products-list-page'),
    'channelsList': open('channels-list-page'),
    'replacements': open('replacements-page'),
    'logisticsNetwork': open('logistics-network-page'),
    'inactivityIntervalsList': open('inactivity-intervals-list-page'),
    'dashboard': open('dashboard-page'),
    'groupIndicatorsValue': open('group-indicators-value-page'),
    'relocationLimits': open('relocation-limits-page'),
    'resourceTypesList': open('resource-types-list-page'),
    'sitesList': open('sites-list-page'),
    'teches': open('teches-list-page'),
    'vehiclesList': open('vehicles-list-page'),
    'unavailabilityIntervalsList': open('unavailability-intervals-list-page'),
    'locationHistory': open('location-history-page'),
    'usageResources': open('usage-resources-page'),
    'cargoPlacement': open('cargo-placement-page'),
};
